import {DataStatus} from 'platform/components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetAdditionalNoteQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {NoteCard, NoteCardForm} from '@dms/shared';

import {RequiredTestIdProps} from 'shared/web';

interface AdditionalNoteProps extends RequiredTestIdProps {
  vehicleId?: string;
  onChange: (values: NoteCardForm | undefined) => void;
  isLoading?: boolean;
  note?: string;
}

export function AdditionalNote(props: AdditionalNoteProps) {
  const {data: note, isLoading: isNoteLoading} = useGetAdditionalNoteQuery(
    {
      vehicleId: props.vehicleId ?? '',
    },
    {
      skip: isNilOrEmpty(props.vehicleId),
    }
  );

  return (
    <DataStatus isLoading={isNoteLoading}>
      <NoteCard
        title={i18n.t('entity.vehicle.labels.vehicleAdditionalNotes')}
        cardVariant="inlineWhite"
        note={note?.note ?? props.note}
        authorId={note?.author.id}
        datetime={note?.createdAt}
        onChange={props.onChange}
        isLoading={props.isLoading}
        data-testid={props['data-testid']}
      />
    </DataStatus>
  );
}
